import React, { ReactNode } from 'react'

export interface RenderIfProps {
  when: boolean
  children: ReactNode
}

const RenderIf = ({ when, children }: RenderIfProps) => {
  return <React.Fragment>{when ? children : null}</React.Fragment>
}
export default RenderIf
